export default __webpack_public_path__ + "static/media/kashier_card.0f83f83b.svg";